import merge from 'lodash/merge'

import { marketEstimationRoutes } from './market-estimation'
import { inAppEventsRoutes } from './in-app-events'
import { appRoutes } from './app'

export const mockEndpoints = merge(
  {},
  appRoutes,
  inAppEventsRoutes,
  marketEstimationRoutes,
)
